import { Inject, Injectable, Optional } from '@angular/core';
import { HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { ENVIRONMENT } from '../constants';

@Injectable()
export class AtxHttpClientInterceptorRequest implements HttpInterceptor {
    constructor(@Optional() @Inject(ENVIRONMENT) private readonly environment) {}

    public intercept(req: HttpRequest<Request>, next: HttpHandler): any {
        let { url, params } = req;

        params = params.set('lang', 'ca');
        url = this.environment[0].apiUrl + url;

        return next.handle(req.clone({ url, params }));
    }
}
